/* eslint-disable max-len */
import React from 'react'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { ErrorBoundary } from '../../../../../components/common/ErrorBoundary'
import { ViewBase } from '../../../../../components/common/ViewBase'
import { ManagementPartnerBase } from '../../../../../components/society/ManagementPartner/ManagementPartnerBase'
import { ManagementPartner } from '../../../../../components/society/ManagementPartner/management_partner'
import { ManagementPartnerCard } from '../../../../../components/society/ManagementPartner/ManagementPartnerCard'
import {
  BOSTADSRATTERNA_BENEFITS_INSURANCE_LINK,
  BOSTADSRATTERNA_BENEFITS_LINK,
} from '../../../../../constants/Links'
import { useCurrentSociety } from '../../../../../hooks/useCurrentSociety'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../../../navigation/reverseDocumentTitle'
import { i18nSocietyType } from '../../../../../i18n'

export const BostadsratternaBenefitsView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(
    reverseDocumentTitle('management:bostadsratterna-benefits', {
      '{{ societyName }}': society?.name,
    })
  )

  return (
    <ErrorBoundary>
      <ViewBase
        title={translate('bostadsratterna.bostadsratternaBenefitsView.title')}
      >
        <ManagementPartnerBase partner={ManagementPartner.BOSTADSRATTERNA}>
          <ManagementPartnerCard
            url={BOSTADSRATTERNA_BENEFITS_LINK}
            title={translate(
              'bostadsratterna.bostadsratternaBenefitsView.benefitsTitle'
            )}
            text={translate(
              'bostadsratterna.bostadsratternaBenefitsView.benefitsText',
              { context: i18nSocietyType(society?.societyTypeDisplayName) }
            )}
          />
          <ManagementPartnerCard
            url={BOSTADSRATTERNA_BENEFITS_INSURANCE_LINK}
            title={translate(
              'bostadsratterna.bostadsratternaBenefitsView.insuranceTitle'
            )}
            text={translate(
              'bostadsratterna.bostadsratternaBenefitsView.insuranceText',
              { context: i18nSocietyType(society?.societyTypeDisplayName) }
            )}
          />
        </ManagementPartnerBase>
      </ViewBase>
    </ErrorBoundary>
  )
}
